import { Flex, SubTitle, Title, styled, useTheme } from '@teko/ds-desktop';
import { BackOutlined, CloseOutlined } from '@teko/ds-icon';
import { useDistanceTerminalContext } from 'contexts';

interface IHeaderModal {
  displayBackButton: boolean;
  backToPreviousLevelLocation?: () => void;
  onClosePopup: () => void;
  title: string;
  subTitle: string;
}

export const HeaderModal = ({
  displayBackButton,
  backToPreviousLevelLocation = () => {},
  onClosePopup,
  title,
  subTitle,
}: IHeaderModal) => {
  const theme = useTheme();
  const { currentTerminal } = useDistanceTerminalContext();

  return (
    <Header>
      {displayBackButton ? (
        <LeftIcon onClick={backToPreviousLevelLocation}>
          <BackOutlined size={20} color={theme.colors.textSecondary} />
        </LeftIcon>
      ) : (
        <Flex width={20} />
      )}
      <Flex direction="column" align="center">
        <Title style={{ fontSize: 15 }}> {title}</Title>
        <SubTitle
          style={{
            fontSize: 12,
            color: theme.colors.textSecondary,
            lineHeight: '16px',
          }}
        >
          {subTitle}
        </SubTitle>
      </Flex>
      {currentTerminal ? (
        <CloseIcon onClick={onClosePopup}>
          <CloseOutlined size={20} color={theme.colors.textSecondary} />
        </CloseIcon>
      ) : (
        <Flex width={20} />
      )}
    </Header>
  );
};

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const LeftIcon = styled.div`
  cursor: pointer;
`;

const CloseIcon = styled.div`
  cursor: pointer;
`;
